import { render, staticRenderFns } from "./LiveTutorialForm.vue?vue&type=template&id=3f46e237"
import script from "./LiveTutorialForm.vue?vue&type=script&lang=js"
export * from "./LiveTutorialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports